import * as R from "ramda";
const getType = (listType) => R.pipe(R.dropLast(1), R.toLower)(listType);
const parseStubLists = (sdmxJson) => R.pipe(
  R.propOr({}, "data"),
  (lists) => R.reduce(
    (acc, key) => {
      const type = getType(key);
      const artefacts = R.map(
        (artefact) => {
          const annotations = R.propOr([], "annotations", artefact);
          const agencyId = artefact.agencyID;
          const code = artefact.id;
          const version = artefact.version;
          const isFinal = artefact.isFinal;
          const label = R.prop("name")(artefact);
          const sdmxId = `${agencyId}:${code}(${version})`;
          const links = artefact.links ? artefact.links : null;
          return {
            annotations,
            agencyId,
            code,
            version,
            isFinal,
            label,
            sdmxId,
            type,
            links
          };
        },
        R.propOr([], key, lists)
      );
      return R.assoc(type, artefacts, acc);
    },
    {},
    R.keys(lists)
  )
)(sdmxJson);
export {
  parseStubLists
};
